import React, { FC, useCallback } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import Button from 'vibo-ui/Button';
import SettingsItem from './SettingsItem';
import Icon, { IconmoonFont } from 'vibo-ui/Icon';

import { useModal } from 'vibo-ui/Modal';

import { Modals } from 'types/enums';

import useStyles from './style';

const ChangeNotification: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { openModal } = useModal();

  const openChangeNotificationsModal = useCallback(
    () =>
      openModal({
        key: Modals.changeNotification,
      }),
    []
  );

  return (
    <SettingsItem>
      <div className={classNames('label', classes.label)}>
        <Icon icon={IconmoonFont['bell-24']} className={classes.generalIcon} />
        <Button onClick={openChangeNotificationsModal} displayType="link">
          {t('changeNotificationSettings')}
        </Button>
      </div>
    </SettingsItem>
  );
};

export default ChangeNotification;
